module.exports = __webpack_public_path__ + "static/media/17PerformancePhotos.7daf4278.jpeg";